import { render, staticRenderFns } from "./ModalNotRegisteredKomship.vue?vue&type=template&id=74c7394a&"
import script from "./ModalNotRegisteredKomship.vue?vue&type=script&lang=js&"
export * from "./ModalNotRegisteredKomship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports